import DefaultMainPage from "../../pages/DefaultMainPage";
import Admin from "./Admin";
import RolePermission from "./RolePermission";

const adminMenuItems = [
    {path: "/admin", component: <Admin/>, label: '관리자 관리'},
    {path: "/admin/role", component: <RolePermission/>, label: '역할 관리'},
];

export const adminRoutes = {
    path: "/admin",
    component: <DefaultMainPage buttons={adminMenuItems}/>,
    children: adminMenuItems
}